import React from "react"
import { type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import DocumentContractCreatePage from "../../../DocumentTemplates/DocumentPages/DocumentContractCreatePage.tsx"
import DocumentContractEditPage from "../../../DocumentTemplates/DocumentPages/DocumentContractEditPage.tsx"
import DocumentProposalCreatePage from "../../../DocumentTemplates/DocumentPages/DocumentProposalCreatePage.tsx"
import DocumentProposalEditPage from "../../../DocumentTemplates/DocumentPages/DocumentProposalEditPage.tsx"
import DocumentTemplateAddPage from "../../../DocumentTemplates/DocumentTemplatePages/DocumentTemplateAddPage.tsx"
import DocumentTemplateEditPage from "../../../DocumentTemplates/DocumentTemplatePages/DocumentTemplateEditPage.tsx"

export const templatesRoutes: RouteObject[] = [
  {
    path: RoutesPaths.documentTemplates.add,
    element: (
      <PermissionGate
        paths={[
          "settings.document_templates.settings_proposal_template_create"
        ]}
      >
        <DocumentTemplateAddPage />
      </PermissionGate>
    )
  },
  {
    path: RoutesPaths.documentTemplates.edit(":id"),
    element: (
      <PermissionGate
        paths={["settings.document_templates.settings_proposal_template_edit"]}
      >
        <DocumentTemplateEditPage />
      </PermissionGate>
    )
  },
  // Proposal Document
  {
    path: RoutesPaths.proposalDocument.create(":templateId", ":leadId"),
    element: <DocumentProposalCreatePage />
  },
  {
    path: RoutesPaths.proposalDocument.edit(":id"),
    element: <DocumentProposalEditPage />
  },
  // Contract Document
  {
    path: RoutesPaths.contractDocument.create.path,
    element: <DocumentContractCreatePage />
  },
  {
    path: RoutesPaths.contractDocument.edit(":id"),
    element: <DocumentContractEditPage />
  }
]
